import { ErrorCodes } from "./error-codes";

export default function getErrorMessage(data: any) {
  if (data?.error) {
    if (data?.message) return data.message;
    const errorCode: ErrorCodes = data?.errorCode;
    if (errorCode === ErrorCodes.NotFound) {
      return "Data not found";
    }
    if (errorCode === ErrorCodes.InvalidToken) {
      return "Please! Login again";
    }
    if (errorCode === ErrorCodes.Unauthorized) {
      return "Access denied";
    }
    if (errorCode === ErrorCodes.UserExists) {
      return "An user already registered with your credential";
    }
    if (errorCode === ErrorCodes.OrganizationDataNeeded) {
      return "No organization data found";
    }
  }
  return null;
}
